module.exports = __webpack_public_path__ + "static/media/johncena.1411e5f7.mp3";